import { IconDefinition } from "@fortawesome/free-regular-svg-icons";

export interface FMenuItem {
  header: string;
  menuID: string;
  enabled?: boolean;
  icon?: IconDefinition;
  invert?: boolean;
}

export interface FMenuOption {
  header: string;
  itemsSource: FMenuItem[];
  command?: { canExcuteCommand: (item: FMenuItem) => boolean };
  itemClicked?: (item: FMenuItem) => void;
  // unused below
  displayMemberPath?: string;
  subItemsPath?: string;
  selectedValuePath?: string;
  dropDownCssClass?: string;
  openOnHover?: boolean,
  isAnimated?: boolean,
}

export class FMenu {

  private _menuId: string;
  private _options: FMenuOption | any;
  private _selectedMenuId: string;

  constructor(menuId: string, options: FMenuOption) {
    this._menuId = menuId;
    this._options = options;
  }

  get menuId(): string {
    return this._menuId;
  }

  get header(): string {
    return this._options.header;
  }

  get itemSources(): FMenuItem[] {
    const result = this._options.itemsSource;
    return result;
  }

  get selectedItem(): any {
    return { menuID: this._selectedMenuId };
  }

  disableMenuItems() {
    if (this._options.command && this._options.command.canExecuteCommand) {
      this.itemSources.forEach(item => {
        item.enabled = this._options.command.canExecuteCommand(item);
      });
    }
  }

  emitMenuItem(item: FMenuItem) {
    this._selectedMenuId = item.menuID;
    if (this._options.itemClicked) {
      this._options.itemClicked(item);
    }
  }
}
